"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cqaCodeAssessmentRiskDictionaries = void 0;
var CQAExampleAssessments = [
    "IDEAL CPT",
    "CPT IS NON-PAYABLE FOR FFS",
    "CPT IS USED FOR TRACKING PURPOSES AND IS NOT CODABLE",
    "UNBUNDLED (SEPARATE PROCEDURE, CCI EDIT, ETC.)",
    "INVALID PRIMARY (E.G., ADD ON CODE)",
    "MISSING OR INVALID ATTESTATION",
    "SPLIT/SHARED SERVICE NON-BILLABLE PROVIDER",
    "WRONG E/M CATEGORY OR CPT SPECIFICITY (INITIAL VS SUBSEQUENT, INPATIENT VS. CRITICAL CARE)(CORRECT CATEGORY)",
    "OVERCODED 1 E/M OR CPT LEVEL (E.G., 8830X)",
    "UNDERCODED 1  E/M LEVEL OR CPT LEVEL",
    "OVERCODED 2 E/M LEVELS OR CPT LEVEL",
    "UNDERCODED 2 E/M LEVELS OR CPT LEVEL",
    "NOT DOCUMENTED",
    "REQUIREMENTS NOT DOCUMENTED/MET",
    "CPT/EM CODE",
    "ADDITIONAL UNIT OF CODED CPT",
    "CORRECT E/M LEVEL OR CPT LEVEL (WRONG LEVEL CODED)",
    "NON-PAYABLE CPT/EM CODE (POST-OP E/M)",
    "TRACKING CPT/EM CODE",
    "DOCUMENTED MACRA/MIPS CODE",
    "PERFORMED CPT",
    "CPT/EM IS DOCUMENTED AS A PAST ENCOUNTER",
    "CPT/EM IS DOCUMENTED AS A FUTURE ENCOUNTER OR RECOMMENDED ENCOUNTER",
    "CPT/EM HAS AN ALTERNATE CODE (HCPCS)"
];
var CQAExampleRoles = [
    "CODABLE",
    "NON-PAYABLE",
    "TRACKING",
    "PERFORMED",
    "MACRA/MIPS",
    "HISTORIC",
    "RECOMMENDED",
    "ALTERNATE CODE"
];
var CQAOptions = { CQAExampleAssessments: CQAExampleAssessments, CQAExampleRoles: CQAExampleRoles };
exports.cqaCodeAssessmentRiskDictionaries = {
    procedure: {
        columnNames: [
            "ASSESSMENT",
            "ACCEPTABILITY\nBY STAR USE CASE",
            "ROLE",
            "CATEGORY"
        ],
        rows: [
            {
                assessment: "IDEAL CPT",
                category: "CORRECT",
                role: "CODABLE"
            },
            {
                assessment: "NOT DOCUMENTED",
                category: "INCORRECT",
                role: "CODABLE"
            },
            {
                assessment: "PERFORMED CPT",
                category: "MISSED",
                role: "PERFORMED"
            }
        ]
    },
    diagnosis: {
        columnNames: [
            "ASSESSMENT",
            "ROLE",
            "CATEGORY",
            "ACCEPTABILITY BY STAR USE CASE"
        ],
        rows: [
            {
                assessment: "IDEAL ICD",
                category: "CORRECT",
                role: "PRIMARY ICD/MEDICAL NECESSITY"
            },
            {
                assessment: "OTHER DIAGNOSIS NOT DOCUMENTED",
                category: "INCORRECT",
                role: "ERROR"
            },
            {
                assessment: "DIAGNOSIS IS DOCUMENTED AS UNCERTAIN, RULE OUT, ETC",
                category: "MISSED",
                role: "UNCERTAIN"
            }
        ]
    },
    modifier: {
        columnNames: [
            "ROLE",
            "DESCRIPTION",
            "Key",
            "ASSESSMENT",
            "CATEGORY",
            "MODIFIER"
        ],
        rows: [
            {
                assessment: "IDEAL",
                category: "CORRECT",
                role: "PAYMENT",
                description: "INCREASED PROCEDURAL SERVICE",
                modifier: "22"
            },
            {
                assessment: "NOT-IDEAL",
                category: "INCORRECT",
                role: "PAYMENT",
                description: "INCREASED PROCEDURAL SERVICE",
                modifier: "22"
            },
            {
                assessment: "IDEAL",
                category: "MISSED",
                role: "INFORMATIONAL",
                description: "PREVENTATIVE SERVICE",
                modifier: "33"
            }
        ]
    }
};
exports.default = CQAOptions;
//# sourceMappingURL=CQAOptions.js.map